import { render, staticRenderFns } from "./ele-right-bottom.vue?vue&type=template&id=3c06d592&scoped=true"
import script from "./ele-right-bottom.vue?vue&type=script&lang=js"
export * from "./ele-right-bottom.vue?vue&type=script&lang=js"
import style0 from "./ele-right-bottom.vue?vue&type=style&index=0&id=3c06d592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06d592",
  null
  
)

export default component.exports